import { type Modification } from '../../types';

export function findActiveModification(
  ingredientId: string,
  activeModifications: Modification[],
) {
  return activeModifications.find(
    (modification) => modification.ingredient?.id === ingredientId,
  );
}
